import { ContactPhoneType } from './contact-phone';

// [DEV-3010] TEMP
export const PHONE_TYPES: ContactPhoneType[] = [
  {
    id: 1,
    code: 'PERSONAL',
    name: 'Личен',
  },
  {
    id: 2,
    code: 'WORK',
    name: 'Служебен',
  },
  {
    id: 3,
    code: 'CONTACT_PERSON',
    name: 'Лице за контакт',
  },
  {
    id: 4,
    code: 'OTHER',
    name: 'Друг',
  },
];
